<template>
  <my-page :loading="isLoading">
    <template #heading>{{ title }}</template>

    <plan-comparison />

    <sideloading-options v-if="!hasPlus" :options="plusOptions" hide-name />
    <html-with-links v-else class="g-text toast" tag="p"
      :html="$t('YOU_ALREADY_HAVE_PLUS', { subscriptionsLink: '/my/billing' })" />

    <html-with-links class="description g-text" :html="$t('PLUS_FEATURES_DESC')"></html-with-links>

    <template #sidebar></template>
  </my-page>
</template>

<script>
import { mapGetters } from 'vuex';
import SideloadingOptions from '@/components/SideloadingOptions.vue';
import PlanComparison from '@/components/PlanComparison.vue';
import MyPage from './components/MyPage.vue';
import HtmlWithLinks from '../../components/HtmlWithLinks.vue';

export default {
  components: {
    MyPage,
    SideloadingOptions,
    HtmlWithLinks,
    PlanComparison,
  },
  data() {
    return {
      isLoading: true,
      plusOptions: [],
    };
  },
  computed: {
    ...mapGetters(['hasPlus']),
    title() {
      return `${this.BRAND_CONFIG.name} PLUS`;
    },
  },
  created() {
    this.$api.getSideloadingOptions('plus')
      .then((response) => {
        this.plusOptions = response;
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/variables';

.content {
  margin-bottom: 25px;
}

.toast {
  background-color: var(--secondary-bg);
  padding: 10px;
  border-radius: 8px;
}

.description {
  margin-top: 25px;

  &::v-deep {
    p+p {
      margin-top: 5px;
    }
  }
}
</style>
